
// src/routes/PrivateRoute.tsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import Layout from '../components/layout/Organizer/Layout';
import { getAuthToken, getUserDetails } from '../utils/auth';

/** Venue admin role — keep in sync with LoginPage gate. */
const VENUE_ROLE = "3";

const isVenueUser = () => {
  const user = getUserDetails();
  if (!user) return false;
  const primary = String(user.userRole ?? "");
  const roles = (user.userRoles || []).map((r: string | number) => String(r));
  return primary === VENUE_ROLE || roles.includes(VENUE_ROLE);
};

const PrivateRoute = ({ children }: { children: JSX.Element }) => {
  const token = getAuthToken();
  const allowed = !!token && isVenueUser();

  // Drop leftover organizer (or other) sessions so /login is not skipped.
  if (token && !isVenueUser()) {
    localStorage.removeItem("token");
    localStorage.removeItem("authUser");
    localStorage.removeItem("venueData");
    localStorage.removeItem("organizerId");
  }

  return allowed ? (
    <Layout>
      {children}
    </Layout>
  ) : (
    <Navigate to="/login" />
  );
};

export default PrivateRoute;
